import actionTypes from "./actionTypes";
import api from "./api";
export default {
    getSummaryReportObjects: (summaryReportId) => ({
        type: actionTypes.GET_SUMMARY_REPORT_OBJECTS,
        payload: {
            promise: () => api.getSummaryReportObjects(summaryReportId)
        },
        meta: { summaryReportId },
        scope: `${actionTypes.GET_SUMMARY_REPORT_OBJECTS}_${summaryReportId}`
    }),
    getSummaryReportObject: (summaryReportId, summaryReportObjectId) => ({
        type: actionTypes.GET_SUMMARY_REPORT_OBJECT,
        payload: {
            promise: () => api.getSummaryReportObject(summaryReportObjectId)
        },
        meta: { summaryReportId, summaryReportObjectId },
        scope: `${actionTypes.GET_SUMMARY_REPORT_OBJECT}_${summaryReportId}_${summaryReportObjectId}`
    }),
    clearData: (exceptSummaryReportId) => ({
        type: actionTypes.CLEAR_DATA,
        exceptSummaryReportId
    })
};
